import { ChangeForgotPasswordArgs } from 'types/api/arguments/change-forgot-password-args'

import { api } from './api'

export const changeForgotPassword = ({
  code,
  password,
  passwordConfirmation,
  fingerprint,
}: ChangeForgotPasswordArgs) =>
  api.post('/users/change_forgot_password', {
    code,
    password,
    password_confirmation: passwordConfirmation,
    fingerprint,
  })
